import { z } from "zod";
export const dmaProteinDtoSchema = z.object({
    useChargeFormula: z.boolean(),
    chargeFormula: z.string(),
    chargeFormulaParameters: z.array(z.number()),
});
